import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as enums from "@/utils/enums";
export default {
  name: "grid",
  props: {
    columns: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: "get"
    },
    search: {
      type: Object,
      required: true
    },
    selectType: {
      type: String,
      default: ""
    },
    // 可选择时候的主键
    rowKey: {
      type: String,
      default: "id"
    },
    formatter: {
      type: Function
    },
    getData: {
      type: Function
    },
    limit: {
      type: Number,
      default: 10
    },
    // 是否保持选择
    keepSelected: {
      type: Boolean,
      default: false
    },
    // 是否展示全局loading
    showLoading: {
      type: Boolean,
      default: true
    },
    rowClassName: {},
    // 是否自动拉取数据
    autoLoadData: {
      type: Boolean,
      default: true
    },
    // server-请求接口模式   client-本地模式
    mode: {
      type: String,
      default: "server"
    },
    // 本地数据
    localData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      page: 1,
      total: 0,
      list: [],
      loading: false,
      singleValue: 0,
      selection: [],
      enums: enums
    };
  },
  computed: {
    pageCount: function pageCount() {
      if (this.total == 0 || this.limit == 0) return 0;
      return parseInt(this.total / this.limit) + 1;
    },
    innerColumns: function innerColumns() {
      var ret = [];
      this.columns && this.columns.forEach(function (i) {
        if (i.disabled) return;
        ret.push(i);
      });
      return ret;
    },
    enumColumns: function enumColumns() {
      return this.innerColumns.filter(function (c) {
        return c.enum;
      });
    },
    formatColumns: function formatColumns() {
      return this.innerColumns.filter(function (c) {
        return c.formatter;
      });
    }
  },
  watch: {
    innerColumns: {
      immediate: true,
      handler: function handler() {
        this.enumColumns.forEach(function (c) {
          if (c.origin_prop) return;
          c.origin_prop = c.prop;
          c.prop = c.prop + "_enum";
        });
        this.formatColumns.forEach(function (c) {
          if (c.origin_prop) return;
          c.origin_prop = c.prop;
          c.prop = c.prop + "_format";
        });
      }
    },
    localData: function localData() {
      if (this.mode == "client") {
        this.requestList(true);
      }
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.autoLoadData) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.requestList(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    // on event
    onCurrentChange: function () {
      var _onCurrentChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(page) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.page = page;
                _context2.next = 3;
                return this.requestList(false);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onCurrentChange(_x) {
        return _onCurrentChange.apply(this, arguments);
      }

      return onCurrentChange;
    }(),
    onSelectionChange: function onSelectionChange(val) {
      this.$emit("selection-change", val);
    },
    onSingleChange: function onSingleChange(val) {
      var _this = this;

      // val 为单选设定的key，由key来寻找行数据
      var result = this.list.filter(function (i) {
        return i[_this.rowKey] == val;
      });
      this.$emit("selection-change", result);
    },
    // other
    searchRefresh: function () {
      var _searchRefresh = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.requestList(true);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function searchRefresh() {
        return _searchRefresh.apply(this, arguments);
      }

      return searchRefresh;
    }(),
    refresh: function () {
      var _refresh = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.requestList(false);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }(),
    clearSelection: function clearSelection() {
      this.singleValue = 0;
      this.$refs.table.clearSelection();
    },
    // format
    formatEnumRows: function formatEnumRows(list) {
      var _this2 = this;

      this.enumColumns.forEach(function (c) {
        list.forEach(function (item) {
          var enumItem = _this2.enums[c.enum];
          var value = "-";

          if (enumItem) {
            value = enumItem.getValue(item[c.origin_prop]) || "-";
          }

          _this2.$set(item, c.prop, value);
        });
      });
    },
    formatCell: function formatCell(column, row, origin_prop) {
      var tag = column.formatter,
          origin = row[origin_prop];
      var value;

      switch (tag) {
        case "datetime":
          value = origin ? this.$pub.ts(origin) : "-";
          break;

        case "date":
          value = origin ? this.$pub.ts(origin, "date") : "-";
          break;

        case "price":
          value = this.$pub.calcPrice(origin);
          break;

        case "empty":
          value = origin || "-";
          break;
      }

      row[origin_prop + "_format"] = value;
    },
    formatCellRows: function formatCellRows(list) {
      var _this3 = this;

      this.formatColumns.forEach(function (c) {
        list.forEach(function (item) {
          _this3.formatCell(c, item, c.origin_prop);
        });
      });
    },
    // request
    requestList: function () {
      var _requestList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var refresh,
            data,
            realData,
            params,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                refresh = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : true;

                if (!(this.mode == "server")) {
                  _context5.next = 12;
                  break;
                }

                if (this.url) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                if (refresh) {
                  this.page = 1;
                }

                params = _objectSpread({
                  page: this.page,
                  limit: this.limit
                }, this.search);
                _context5.next = 8;
                return this.$http[this.method](this.url, params, {
                  showLoading: this.showLoading
                });

              case 8:
                data = _context5.sent;

                if (data.data) {
                  realData = data.data;
                  this.total = data.total;
                } else {
                  realData = data;
                }

                _context5.next = 15;
                break;

              case 12:
                data = this.localData;
                this.total = this.localData.length;
                realData = this.localData;

              case 15:
                this.formatEnumRows(realData);
                this.formatCellRows(realData);
                this.formatter && this.formatter(realData);
                this.getData && this.getData(data);
                this.list = realData;

                if (this.list.length == 0 && !refresh && this.page > 1) {
                  this.page--;
                  this.requestList(refresh);
                }

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function requestList() {
        return _requestList.apply(this, arguments);
      }

      return requestList;
    }(),
    onSortChange: function onSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;
      this.$emit("sort", {
        prop: prop,
        order: order
      });
    }
  }
};